/**
 *  @class
 *  @function ProductComparePanel
 */
if (!customElements.get('product-compare-panel')) {
    class ProductComparePanel extends HTMLElement {
        constructor() {
            super();
            this.toggle = this.querySelector('.compare-toggle');
            this.drawer = this.querySelector('.compare-drawer');
            this.clear = this.querySelector('.compare-clear');
            this.start = this.querySelector('.compare-start');
            this.modal = this.querySelector('.product-compare-modal');
            this.table = this.querySelector('product-compare-table');
            this.max = Number(this.dataset.max);
            this.href = '';
            this.drawerDirty = true;
        }

        connectedCallback() {
            if (this.toggle) setTimeout(() => this.toggle.classList.add('compare-toggle--active'), 250);
            this.addEventListeners();
            this.updateCompareComponents();
        }

        addEventListeners() {
            this.onCheckboxClickBound = this.onCheckboxClick.bind(this);
            this.onFacetsUpdatedBound = this.onFacetsUpdated.bind(this);
            if (this.toggle) this.toggle.addEventListener('click', this.onButtonClick.bind(this));
            this.drawer.addEventListener('click', this.onRemoveClick.bind(this));
            this.clear.addEventListener('click', this.onClearClick.bind(this));
            this.start.addEventListener('click', this.onStartClick.bind(this));
            document.addEventListener('change', this.onCheckboxClickBound);
            document.addEventListener('facets:updated', this.onFacetsUpdatedBound);
        }

        disconnectedCallback() {
            document.removeEventListener('change', this.onCheckboxClickBound);
            document.removeEventListener('facets:updated', this.onFacetsUpdatedBound);
        }

        onFacetsUpdated() {
            this.drawerDirty = true;
            this.updateCompareComponents();
        }

        getSelectedProducts() {
            return JSON.parse(localStorage.getItem('compare-products-vision')) || [];
        }

        addToCompare(productId, productUrl, productHandle) {
            const compareProducts = this.getSelectedProducts();
            if (!compareProducts.some(product => product.id === productId)) {
                compareProducts.push({ id: productId, url: productUrl, handle: productHandle });
                localStorage.setItem('compare-products-vision', JSON.stringify(compareProducts));
                this.drawerDirty = true;
                this.updateCompareComponents();
            }
        }

        removeFromCompare(productId) {
            const compareProducts = this.getSelectedProducts().filter(product => product.id !== productId);
            localStorage.setItem('compare-products-vision', JSON.stringify(compareProducts));
            this.drawerDirty = true;
            this.updateCompareComponents();
        }

        onCheckboxClick(event) {
            if (event.target.classList.contains('product-card-compare--checkbox')) {
                const { productId, productUrl, productHandle } = event.target.dataset;
                if (event.target.checked) {
                    if (this.getCompareCount() < this.max) {
                        this.addToCompare(productId, productUrl, productHandle);
                    }
                } else {
                    this.removeFromCompare(productId);
                }
            }
        }

        updateCompareCheckboxes(products) {
            const count = products.length;
            document.querySelectorAll('.product-card-compare--checkbox').forEach(checkbox => {
                const isChecked = products.some(product => product.id === checkbox.dataset.productId);
                checkbox.checked = isChecked;
                checkbox.disabled = !isChecked && count >= this.max;
            });
        }

        onRemoveClick(event) {
            if (event.target.classList.contains('compare-remove')) {
                const productId = event.target.dataset.productId;
                this.removeFromCompare(productId);
                event.target.closest('product-card-small').remove();
            }
        }

        onClearClick() {
            localStorage.removeItem('compare-products-vision');
            this.drawerDirty = true;
            this.updateCompareComponents();
            this.drawer.querySelector('.compare-drawer--list').innerHTML = '<div class="compare-drawer--list-item"></div>'.repeat(this.max);
            this.closeDrawer();
        }

        onStartClick() {
            this.modal.show();
            this.table.dispatchEvent(new CustomEvent('render-product-compare-modal', { bubbles: true }));
        }

        openDrawer() {
            OverlayManager.open(this.drawer);
            this.drawer.focus();
        }

        closeDrawer() {
            OverlayManager.close(this.drawer);
            this.drawer.blur();
        }

        onButtonClick() {
            if (this.drawerDirty) {
                this.renderProducts();
                this.drawerDirty = false;
            }
            this.openDrawer();
        }

        getCompareCount() {
            return this.getSelectedProducts().length;
        }

        updateCompareCounters(count) {
            document.querySelectorAll('.compare-counter').forEach(counter => {
                counter.textContent = count;
            });
        }

        updateStartButton(count) {
            this.start.disabled = count === 0;
        }

        async renderProducts() {
            const compareProducts = this.getSelectedProducts();

            if (!compareProducts.length) {
                this.drawer.querySelector('.compare-drawer--list').innerHTML = '<div class="compare-drawer--list-item"></div>'.repeat(this.max);
                return;
            }

            const returnArray = await Promise.all(compareProducts.map(async (product) => {
                const response = await fetch(`${product.url}?sections=product-compare-card`);
                const data = await response.json();
                return this.getSectionInnerHTML(data['product-compare-card'], '.shopify-section');
            }));

            const returnHtml = returnArray.join('') + '<div class="compare-drawer--list-item"></div>'.repeat(this.max - compareProducts.length);
            this.drawer.querySelector('.compare-drawer--list').innerHTML = returnHtml;
        }

        getSectionInnerHTML(html, selector) {
            return new DOMParser()
                .parseFromString(html, 'text/html')
                .querySelector(selector).innerHTML;
        }

        updateCompareComponents() {
            const products = this.getSelectedProducts();
            const count = products.length;
            this.updateCompareCheckboxes(products);
            this.updateCompareCounters(count);
            this.updateStartButton(count);
        }
    }

    customElements.define('product-compare-panel', ProductComparePanel);
}
